import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';

class SelectCountryField extends Component {
    state = {
        selectFieldValue: "",
        selectFieldOptions: [
            {name: 'Any Country', countryCode: ""},
        ]
    };

    constructor() {
        super();
    };

    componentDidMount () {
        Service.event.onFetchCountriesStatus.add((data) => {
            this.setState({
                selectFieldOptions: this.state.selectFieldOptions.concat(data.results),
            });
        });
        Service.fetchCountries();
    };

    componentWillUnmount() {

    }

    onSelectFieldChange = (event) => {
        this.props.controlFunc(event.target.value);
        this.setState({
            selectFieldValue : event.target.value
        })
    }

    render() {
        return (
            <select
                className = { this.props.className }
                onChange = { this.onSelectFieldChange }
            >
                {this.state.selectFieldOptions.map(opt => {
                    return (
                        <option
                            key={opt.name}
                            value={opt.countryCode}>{opt.name}</option>
                    );
                })}
            </select>
        );
    }
}
export default SelectCountryField;
